import { DEVICE_ID_KEY } from '@/config/constants';
import { storage } from '@/utils/storage';

/**
 * Trả về device id đã lưu; nếu chưa có thì tạo UUID mới và lưu.
 * Dùng cho header `X-Device-Id` (login / refresh / logout).
 */
export function getOrCreateDeviceId(): string {
  const existing = storage.get<string>(DEVICE_ID_KEY);
  if (existing) return existing;
  const id =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : generateFallbackUuid();
  storage.set(DEVICE_ID_KEY, id);
  return id;
}

/** Ghi đè device id theo phản hồi server sau đăng nhập. */
export function setDeviceId(id: string): void {
  storage.set(DEVICE_ID_KEY, id);
}

export function getDeviceId(): string | null {
  return storage.get<string>(DEVICE_ID_KEY);
}

function generateFallbackUuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
